/**
 * Error503 — Branded 503 Service Unavailable page (#2454)
 *
 * No ConfigProvider / AuthProvider / BrandProvider dependency.
 */

import { PAGE_CSS, Logo, ErrorCard } from "./shared";

export function Error503() {
  return (
    <>
      <style>{PAGE_CSS}</style>
      <div className="err-page">
        <ErrorCard
          code="503"
          title="Service unavailable"
          message="2hives.ai is temporarily down for maintenance or under heavy load. We'll be back shortly — please try again in a minute."
          accentVar="--brand-status-warning"
          accentBg="var(--brand-status-warning-bg)"
          accentBorder="rgba(232,140,0,0.25)"
          showRetry
        >
          <Logo />
        </ErrorCard>
      </div>
    </>
  );
}
